/**
 *
 *
 *
 *
 *
 */
import { o_util, win } from "../common/namespaces";
import type { GlobalUtils } from "../exports/index.js";
import type { OttoNexus } from "../exports/nexus.js";

export type { DomRaw } from "../lib/dom/index.js";

/**
 *
 *
 *
 */
export type DomSync = GlobalUtils["dom"];

/**
 *
 *
 *
 */
export const domSync: DomSync = o_util.dom;

/**
 *
 *
 *
 *
 */
export type DomAsync = OttoNexus["dom"];

/**
 *
 *
 *
 */
export const domAsync: DomAsync = win.otto.dom;
